import React, { useMemo, useState } from "react";
import Chat from "../chat";
import useBaseRequest from "@/hooks/useBaseRequest";
import { getInitData } from "@/api/index";
import { utils } from "@sui/runtime";
import { useEmbedOptions } from "@/components/EmbedWelcome";

function Merge(props) {
  const { single, ...others } = props;
  const [loading, setLoading] = useState(false);
  //是否是单智能体 standalone  true 是 false 否
  const [standalone,setStandalone] = useState(false);
  const {
    runAsync: requestInit,
    loading: loadingInitData,
    data: initData,
  } = useBaseRequest(() => getInitData({}), {
    // manual: true,
    onSuccess(res) {
      console.log(res,"入口页面的接口调用")
        setLoading(true);
        setStandalone(res?.data?.standalone)
    },
  });

  // 通过url参数判断是否为嵌入的页面
  const embed = useMemo(() => {
    const _embed = utils.getQueryParam("embed");
    return _embed == "1" || _embed == "true";
  }, []);

  // 获取嵌入配置
  const embedOptions = useEmbedOptions();

  console.log(initData, "初始化数据");
  //enabledagents  开启多智能体
  return loading ? (
    initData?.data?.enabledagents && !single ? (
      <>
        {window.location.hash.includes("single") ? (
          <>
            <Chat
              {...others}
              single={single}
              mode={standalone ? "single" : "multiple"}
              embed={embed}
              embedOptions={embedOptions}
            />
          </>
        ) : (
          <Chat
            {...others}
            mode={standalone ? "single" :  "multiple"}
            embed={embed}
            embedOptions={embedOptions}
          />
        )}
      </>
    ) : (
      <Chat
        {...others}
        single={single}
        mode={standalone ? "single" : "multiple"}
        embed={embed}
        embedOptions={embedOptions}
      />
    )
  ) : undefined;
}

export default Merge;
